import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SubscriberSuccessPageComponent } from '@x/ecommerce-shop/app/subscriber-checkout/components/subscriber-success-page/subscriber-success-page.component';
import { subscriberResolver } from '@x/ecommerce-shop/app/subscriber-checkout/resolvers/subscriber.resolver';
import { SubscriberCheckoutPageComponent } from '@x/ecommerce-shop/app/subscriber-checkout/subscriber-checkout-page.component';

const routes: Routes = [
  {
    path: 'checkout/:subscriberVarientId',
    resolve: { subscriber: subscriberResolver },
    children: [
      {
        path: '',
        component: SubscriberCheckoutPageComponent,
      },
      {
        path: 'success',
        component: SubscriberSuccessPageComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SubscriberRoutingModule {}
